// Generated by purs version 0.15.15
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_BeginCheckout from "../Restaumatic.Analytics.Types.BeginCheckout/index.js";
import * as Restaumatic_Analytics_Types_Event from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic_Analytics_Types_ExperienceImpression from "../Restaumatic.Analytics.Types.ExperienceImpression/index.js";
import * as Restaumatic_Analytics_Types_Item from "../Restaumatic.Analytics.Types.Item/index.js";
import * as Restaumatic_Analytics_Types_ItemList from "../Restaumatic.Analytics.Types.ItemList/index.js";
import * as Restaumatic_Analytics_Types_PurchaseItem from "../Restaumatic.Analytics.Types.PurchaseItem/index.js";
import * as Restaumatic_Analytics_Types_SetCheckoutOption from "../Restaumatic.Analytics.Types.SetCheckoutOption/index.js";
import * as Restaumatic_Analytics_Types_VisitPage from "../Restaumatic.Analytics.Types.VisitPage/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var priceIsSymbol = {
    reflectSymbol: function () {
        return "price";
    }
};
var getField = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord(priceIsSymbol)()));
var quantityIsSymbol = {
    reflectSymbol: function () {
        return "quantity";
    }
};
var getField1 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord(quantityIsSymbol)()));
var getField2 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "name";
    }
})()));
var getField3 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "category";
    }
})()));
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var show = /* #__PURE__ */ Data_Show.show(Restaumatic_Analytics_Types_ItemList.showItemList);
var getField4 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "list";
    }
})()));
var selectedOptionIsSymbol = {
    reflectSymbol: function () {
        return "selectedOption";
    }
};
var getField5 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_SetCheckoutOption.hasFieldSetCheckoutOption(/* #__PURE__ */ Data_Record.hasFieldRecord(selectedOptionIsSymbol)()));
var selectedValueIsSymbol = {
    reflectSymbol: function () {
        return "selectedValue";
    }
};
var getField6 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_SetCheckoutOption.hasFieldSetCheckoutOption(/* #__PURE__ */ Data_Record.hasFieldRecord(selectedValueIsSymbol)()));
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var itemsIsSymbol = {
    reflectSymbol: function () {
        return "items";
    }
};
var hasFieldRecord = /* #__PURE__ */ Data_Record.hasFieldRecord(itemsIsSymbol)();
var getField7 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(hasFieldRecord));
var getField8 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "total";
    }
})()));
var affiliationIsSymbol = {
    reflectSymbol: function () {
        return "affiliation";
    }
};
var getField9 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(/* #__PURE__ */ Data_Record.hasFieldRecord(affiliationIsSymbol)()));
var shippingIsSymbol = {
    reflectSymbol: function () {
        return "shipping";
    }
};
var getField10 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(/* #__PURE__ */ Data_Record.hasFieldRecord(shippingIsSymbol)()));
var getField11 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "transactionId";
    }
})()));
var couponIsSymbol = {
    reflectSymbol: function () {
        return "coupon";
    }
};
var getField12 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(/* #__PURE__ */ Data_Record.hasFieldRecord(couponIsSymbol)()));
var getField13 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_BeginCheckout.hasFieldBeginCheckout(hasFieldRecord));
var sum = /* #__PURE__ */ Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Numeric.additiveNumber);
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode);
var encodeRecordCons2 = /* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1({
    reflectSymbol: function () {
        return "value";
    }
})(encodeWithOptionsOther));
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var encodeWithOptionsOther3 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(quantityIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))(priceIsSymbol)(encodeWithOptionsOther))({
    reflectSymbol: function () {
        return "item_name";
    }
})(encodeWithOptionsOther1))({
    reflectSymbol: function () {
        return "item_list_id";
    }
})(encodeWithOptionsOther2))({
    reflectSymbol: function () {
        return "item_category";
    }
})(encodeWithOptionsOther1))));
var currencyIsSymbol = {
    reflectSymbol: function () {
        return "currency";
    }
};
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons2(itemsIsSymbol)(encodeWithOptionsOther3))(currencyIsSymbol)(encodeWithOptionsOther1)));
var encode1 = /* #__PURE__ */ Foreign_Generic_Class.encode(Foreign_Generic_Class.unitEncode);
var encode2 = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons2({
    reflectSymbol: function () {
        return "transaction_id";
    }
})(encodeWithOptionsOther1))(shippingIsSymbol)(encodeWithOptionsOther))(itemsIsSymbol)(encodeWithOptionsOther3))(currencyIsSymbol)(encodeWithOptionsOther1))(couponIsSymbol)(encodeWithOptionsOther2))(affiliationIsSymbol)(encodeWithOptionsOther1)));
var encode3 = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(selectedValueIsSymbol)(encodeWithOptionsOther1))(selectedOptionIsSymbol)(encodeWithOptionsOther1)));
var encode4 = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons1({
    reflectSymbol: function () {
        return "exp_variant_string";
    }
})(encodeWithOptionsOther1)));
var getField14 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_ExperienceImpression.hasFieldExperienceImpress(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "experiment";
    }
})()));
var getField15 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_ExperienceImpression.hasFieldExperienceImpress(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "variant";
    }
})()));
var encode5 = /* #__PURE__ */ Foreign_Generic_Class.encode(Restaumatic_Analytics_Types_VisitPage.encodeVisitPage);
var itemValue = function (item) {
    return Data_Money_Rounded.toNumber(getField(Type_Proxy["Proxy"].value)(item)) * Data_Int.toNumber(getField1(Type_Proxy["Proxy"].value)(item));
};
var convertItem = function (item) {
    return {
        item_name: getField2(Type_Proxy["Proxy"].value)(item),
        quantity: getField1(Type_Proxy["Proxy"].value)(item),
        price: Data_Money_Rounded.toNumber(getField(Type_Proxy["Proxy"].value)(item)),
        item_category: getField3(Type_Proxy["Proxy"].value)(item),
        item_list_id: map(show)(getField4(Type_Proxy["Proxy"].value)(item))
    };
};
var toPlatformEvent = function (currency) {
    var setCheckoutOption = function (e) {
        return {
            selectedOption: getField5(Type_Proxy["Proxy"].value)(e),
            selectedValue: getField6(Type_Proxy["Proxy"].value)(e)
        };
    };
    var removeFromCart = function (item) {
        return {
            currency: currency,
            value: itemValue(item),
            items: [ convertItem(item) ]
        };
    };
    var purchase = function (e) {
        return {
            items: map1(convertItem)(getField7(Type_Proxy["Proxy"].value)(e)),
            value: Data_Money_Rounded.toNumber(getField8(Type_Proxy["Proxy"].value)(e)),
            currency: currency,
            affiliation: getField9(Type_Proxy["Proxy"].value)(e),
            shipping: Data_Money_Rounded.toNumber(getField10(Type_Proxy["Proxy"].value)(e)),
            transaction_id: getField11(Type_Proxy["Proxy"].value)(e),
            coupon: getField12(Type_Proxy["Proxy"].value)(e)
        };
    };
    var beginCheckout = function (e) {
        return {
            items: map1(convertItem)(getField13(Type_Proxy["Proxy"].value)(e)),
            value: sum(map1(itemValue)(getField13(Type_Proxy["Proxy"].value)(e))),
            currency: currency
        };
    };
    var addToCart = function (item) {
        return {
            currency: currency,
            value: itemValue(item),
            items: [ convertItem(item) ]
        };
    };
    return function (v) {
        if (v instanceof Restaumatic_Analytics_Types_Event.AddToCart) {
            return new Data_Maybe.Just({
                name: "add_to_cart",
                value: encode(addToCart(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.LocateMe) {
            return new Data_Maybe.Just({
                name: "locate_me",
                value: encode1(Data_Unit.unit)
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.RemoveFromCart) {
            return new Data_Maybe.Just({
                name: "remove_from_cart",
                value: encode(removeFromCart(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.BeginCheckout) {
            return new Data_Maybe.Just({
                name: "begin_checkout",
                value: encode(beginCheckout(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.Purchase) {
            return new Data_Maybe.Just({
                name: "purchase",
                value: encode2(purchase(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.SetCheckoutOption) {
            return new Data_Maybe.Just({
                name: "set_checkout_option",
                value: encode3(setCheckoutOption(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ExperienceImpression) {
            return new Data_Maybe.Just({
                name: "experience_impression",
                value: encode4({
                    exp_variant_string: "RE-" + (getField14(Type_Proxy["Proxy"].value)(v.value0) + ("-" + getField15(Type_Proxy["Proxy"].value)(v.value0)))
                })
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.VisitPage) {
            return new Data_Maybe.Just({
                name: "visit_page",
                value: encode5(v.value0)
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDelivery) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseTakeaway) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseAddress) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDineIn) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDate) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.FindAddress) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ReviewGoogleLinkShown) {
            return new Data_Maybe.Just({
                name: "review_google_link_shown",
                value: encode1(Data_Unit.unit)
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.NotOverlappingDishes) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.SuggestionResult) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.OrderingImpossibleAlert) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.AnalyticsV4 (line 63, column 28 - line 81, column 43): " + [ v.constructor.name ]);
    };
};
export {
    convertItem,
    itemValue,
    toPlatformEvent
};
